// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '../../Geometry';
import { BaseMap } from './BaseMap';
import { SymbolMapItem } from './SymbolMapItem';
export class IndustryMap extends BaseMap {
    constructor(parentSectorMap, industryName, data) {
        super();
        this.headerRectangle = Rectangle.Empty();
        this.bodyRectangle = Rectangle.Empty();
        this.isSelected = false;
        this.isHidden = false;
        this.parentSectorMap = parentSectorMap;
        this.industryName = industryName;
        data.forEach((x) => {
            this.addItem(new SymbolMapItem(this, x));
        });
    }
    get Visible() {
        return !this.isHidden && this.isVisible();
    }
    get VisibleCount() {
        return this.getVisibleCount();
    }
    getSymbolBackgroundColor(intervalDot) {
        return this.parentSectorMap.getSymbolBackgroundColor(intervalDot);
    }
    recalculateArea() {
        const rect = new Rectangle(this.Rectangle.X + IndustryMap.BORDER, this.Rectangle.Y, this.Rectangle.Width - 2 * IndustryMap.BORDER, this.Rectangle.Height);
        const headerHeight = !this.isSelected ? Math.min(this.parentSectorMap.industryHeaderHeight, rect.Height) : 0;
        this.headerRectangle = new Rectangle(rect.X, rect.Y, rect.Width, headerHeight);
        this.bodyRectangle = new Rectangle(rect.X, rect.Y + headerHeight, rect.Width, rect.Height - headerHeight);
        this.recalculateTreeMap(this.bodyRectangle);
    }
}
IndustryMap.BORDER = 2;
